import { useMsal } from '@azure/msal-react';
import { useQuery } from '@tanstack/react-query';
import { apiFetch, type AuditEntry, type Dashboard } from './client';

export function useDashboard() {
  const { instance } = useMsal();
  return useQuery({
    queryKey: ['dashboard'],
    queryFn: () => apiFetch<Dashboard>(instance, '/api/dashboard'),
  });
}

export function useAudit() {
  const { instance } = useMsal();
  return useQuery({
    queryKey: ['audit'],
    queryFn: () => apiFetch<AuditEntry[]>(instance, '/api/audit'),
  });
}
